import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ButtonContainer,
  ContentContainer,
  MessageContainer
} from 'Pages/updatePassword/components/success/style';
import { Button, ButtonSizes, ButtonWidth } from 'Shared/components/design/button/Button';
import {ICON_IDS} from "Shared/components/icons/constants";
import Icon from 'Shared/components/icons/icon';

type SuccessProps = {
  signInRedirect: () => void;
}

/**
 * Renders Success slide
 */
function Success({
  signInRedirect
}: SuccessProps): JSX.Element {
  const { t } = useTranslation("updatePassword");

  /**
   * Auto-redirect to sign in after 3 seconds upon successful password update
   */
  useEffect(() => {
    const timer = setTimeout(() => {
      signInRedirect();
    }, 3000);

    return () => clearTimeout(timer);
  }, [signInRedirect]);

  return(
    <ContentContainer>
      <MessageContainer>
        <Icon iconId={ICON_IDS.EMAIL_CHECK_OUTLINE}/>
        <span>
          {t('UpdatePassword--success-message')}
        </span>
      </MessageContainer>
      <ButtonContainer>
        <Button
          size     = {ButtonSizes.LARGE}
          width    = {ButtonWidth.FULL}
          onClick  = {signInRedirect}>
          {t('UpdatePassword--success-buttonLabel')}
        </Button>
      </ButtonContainer>
    </ContentContainer>
  );
}

export default Success;

